'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _Button = require('../Core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ProfileFirstName = require('../Profile/ProfileFirstName');

var _ProfileFirstName2 = _interopRequireDefault(_ProfileFirstName);

var _actions = require('../../actions');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var rules = function rules() {
  return {
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
      margin: '30px 0 25px',
      boxSizing: 'border-box'
    },
    profile: {
      display: 'flex',
      width: '100%'
    },
    profileContainer: {
      marginLeft: '24px'
    },
    profileAvatar: {
      width: '48px',
      height: '48px',
      marginLeft: '6px',
      borderRadius: '50%',
      backgroundColor: '#d8d8d8',
      overflow: 'hidden'
    },
    profileCTA: {
      margin: '0 5px',
      fontSize: '12px',
      minWidth: '110px'
    },
    profilePicture: {
      maxWidth: '100%',
      maxHeight: '100%'
    },
    profileButton: {
      fontSize: '12px',
      border: '1px solid currentColor',
      marginRight: '8px'
    },
    profileName: {
      textAlign: 'left',
      marginBottom: '16px',
      color: '#666',
      fontSize: '18px'
    },
    spacer: {
      marginBottom: '1rem'
    }
  };
};

var NavbarProfile = function (_Component) {
  _inherits(NavbarProfile, _Component);

  function NavbarProfile() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavbarProfile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavbarProfile.__proto__ || Object.getPrototypeOf(NavbarProfile)).call.apply(_ref, [this].concat(args))), _this), _this.handleLogout = function (event) {
      event.preventDefault();

      _this.props.logout();
      _this.props.closeMenu();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavbarProfile, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          loggedIn = _props.loggedIn,
          login = _props.login,
          signUp = _props.signUp,
          profile = _props.profile,
          config = _props.config,
          styles = _props.styles;


      var loginDisabled = login.disabledInProfile;
      var loginText = login.text;
      var loginAccessibleLabel = login.loginAccessibleLabel;
      var loginPath = login.path;
      var loginCallback = login.callback;
      var loginEl = typeof loginCallback === 'function' ? 'button' : 'a';

      var signUpDisabled = signUp.disabledInProfile;
      var signUpText = signUp.textInMenu || signUp.text;
      var accessibleTextLabel = signUp.accessibleTextLabel;
      var signUpPath = signUp.path;
      var signUpCallback = signUp.callback;
      var signUpEl = typeof signUpCallback === 'function' ? 'button' : 'a';

      var color = config.color;
      var inverseColor = config.inverseColor;

      var navbarGoSignUp = function navbarGoSignUp(evt) {
        (0, _actions.goSignUp)(evt, 'menu');
      };

      if (!loggedIn && loginDisabled && signUpDisabled) {
        return (0, _preact.h)('div', { className: styles.spacer });
      }

      return (0, _preact.h)(
        'div',
        { className: styles.wrapper },
        loggedIn ? (0, _preact.h)(
          'div',
          { className: styles.profile },
          (0, _preact.h)(
            'div',
            { className: styles.profileAvatar },
            profile.picture && (0, _preact.h)('img', { src: profile.picture, className: styles.profilePicture })
          ),
          (0, _preact.h)(
            'div',
            { className: styles.profileContainer },
            (0, _preact.h)(
              'div',
              { className: styles.profileName },
              (0, _preact.h)(_ProfileFirstName2.default, { name: profile.name })
            ),
            (0, _preact.h)(
              _Button2.default,
              _extends({ href: '/meus-dados/alterar-dados/', as: 'a', color: color, dense: true, className: styles.profileButton }, (0, _utils.getAttrsGtm)("Editar dados", { clicktype: 'menu' })),
              'Editar dados'
            ),
            (0, _preact.h)(
              _Button2.default,
              _extends({ onClick: this.handleLogout, color: color, dense: true, className: styles.profileButton }, (0, _utils.getAttrsGtm)("Sair", { clicktype: 'menu' })),
              'Sair'
            )
          )
        ) : [(0, _preact.h)(
          _Button2.default,
          _extends({
            href: signUpPath,
            onClick: navbarGoSignUp,
            color: color,
            as: signUpEl,
            'aria-label': accessibleTextLabel,
            className: styles.profileCTA
          }, (0, _utils.getAttrsGtm)(signUpText, { clicktype: 'menu' })),
          signUpText
        ), (0, _preact.h)(
          _Button2.default,
          _extends({
            href: loginPath,
            onClick: _actions.goLogin,
            color: inverseColor,
            background: color,
            as: loginEl,
            className: styles.profileCTA
          }, (0, _utils.getAttrsGtm)(loginText, { clicktype: 'menu' }), {
            'aria-label': loginAccessibleLabel
          }),
          loginText
        )]
      );
    }
  }]);

  return NavbarProfile;
}(_preact.Component);

exports.default = (0, _preactFela.connect)(rules)(NavbarProfile);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Navbar/NavbarProfile.js
// module id = 197
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38